import React, { useState } from 'react'

import { Button, Grid, InputAdornment, InputLabel } from '@material-ui/core'
import CurrencyTextField from '@unicef/material-ui-currency-textfield'
import PropTypes from 'prop-types'

import styles from '../products.styles'

const EditPrice = ({ data, handleSubmit, onCancel }) => {
  const [editedData, setEditedData] = useState(data)
  const classes = styles()

  const onSubmit = (event) => {
    event.preventDefault()
    handleSubmit(editedData)
  }

  return (
    <form noValidate onSubmit={onSubmit} autoComplete="off">
      <Grid container className={classes.root} justifyContent="center">
        <Grid item xs={12} sm={12} md={6} justifyContent="center">
          <InputLabel className={classes.labelSize}>Precio ($)</InputLabel>
          <CurrencyTextField
            currencySymbol="$"
            textAlign="left"
            decimalPlaces={0}
            outputFormat="string"
            variant="outlined"
            inputProps={{
              inputProps: { min: 0 },
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
              defaultValue: editedData.regularPrice,
              onChange: ({ target }) => {
                setEditedData({ ...editedData, regularPrice: target.value })
              },
            }}
          />
        </Grid>
      </Grid>
      <Grid container alignItems="center" justifyContent="center">
        <div className={classes.wrapper}>
          <Button
            variant="contained"
            className={`${classes.btnBackgroundErrorPrice} ${classes.btnUpload}`}
            btnErrorPrice
            onClick={onCancel}
          >
            Cancelar
          </Button>
        </div>
        <Button type="submit" className={`${classes.btnNewProduct} ${classes.btnUpload}`}>
          {editedData.id ? 'Actualizar' : 'Aceptar'}
        </Button>
      </Grid>
    </form>
  )
}

EditPrice.propTypes = {
  data: PropTypes.shape({
    stockQuantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}

export default EditPrice
